<script setup lang="ts">
import {cx} from 'class-variance-authority'
import type {SuccessionBlock} from '~/types/legacy'
import type {WorkshopSuccession} from '~/types/workshop'
import type {Populated} from '~/types/populated'
import StatementPerson from '~/components/workshop/statement-person.vue'
import {resolveMediaProps} from '~/utils/relations'

const props = defineProps<{
  data: Exclude<Populated<SuccessionBlock> | Populated<WorkshopSuccession>, undefined>
}>()
</script>

<template>
  <Container
    class="flex border-spacing-3 flex-col items-center justify-center border-b border-gray-200 bg-gray-50 !font-main"
  >
    <div class="text-center">
      <Heading as="h2" size="caption" class="mx-auto max-w-xs"> {{ data.eyebrow }}</Heading>
      <Heading as="h3" size="medium" class="mx-auto mb-14 mt-4 flex max-w-sm justify-center text-center">
        {{ data.title }}
      </Heading>
    </div>

    <NuxtImg
      v-if="data.person"
      loading="lazy"
      format="webp"
      class="h-24 w-24 rounded-full"
      v-bind="resolveMediaProps(data.person?.image)"
      :width="128"
      :height="128"
    />

    <span class="pt-6 font-body text-xl font-medium">{{ data.person?.name }}</span>
    <span class="text-gray-500">Co-founder <span class="text-main-500">Uppl.io</span></span>
    <span class="text-gray-700">London, UK</span>

    <Action
      class="mt-6"
      as="link"
      to="https://webamboos.com/projects/logistics/warehouse-management-system-aggregator"
      >{{ $t('warehouse.read_story') }}</Action
    >
  </Container>
</template>
